export default __webpack_public_path__ + "static/media/bottle-brut-glasses.5b7f3e00.jpg";